import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { PreviewToneAPI } from '../api/previewtone/previewtoneapi';
import { PreviewToneRequest } from '../api/previewtone/previewtonerequest';
import { PreviewToneResponse } from '../api/previewtone/previewtoneresponse';
import { BuyToneAPI } from '../api/tune/buytune/buytoneapi';
import { BuyToneRequest } from '../api/tune/buytune/buytonerequest';
import { BuyToneResponse } from '../api/tune/buytune/buytoneresponse';
import { DeleteToneAPI } from '../api/tune/deletetone/deletetoneapi';
import { DeleteToneRequest } from '../api/tune/deletetone/deletetonerequest';
import { DeleteToneResponse } from '../api/tune/deletetone/deletetoneresponse';
import { GetTonePriceAPI } from '../api/tune/gettuneprice/gettonepriceapi';
import { GetTonePriceRequest } from '../api/tune/gettuneprice/gettonepricerequest';
import { GetTonePriceResponse } from '../api/tune/gettuneprice/gettonepriceresponse';
import { GiftToneAPI } from '../api/tune/gifttune/gifttoneapi';
import { GiftToneRequest } from '../api/tune/gifttune/gifttonerequest';
import { GiftToneResponse } from '../api/tune/gifttune/gifttoneresponse';
import { LikeToneAPI } from '../api/tune/liketune/liketoneapi';
import { LikeToneRequest } from '../api/tune/liketune/liketonerequest';
import { LikeToneResponse } from '../api/tune/liketune/liketoneresponse';
import { ReferToneAPI } from '../api/tune/refertone/refertoneapi';
import { ReferToneRequest } from '../api/tune/refertone/refertonerequest';
import { ReferToneResponse } from '../api/tune/refertone/refertoneresponse';
import { AddToWishlistAPI } from '../api/wishlist/addtowishlist/addtowishlistapi';
import { AddToWishlistRequest } from '../api/wishlist/addtowishlist/addtowishlistrequest';
import { AddToWishlistResponse } from '../api/wishlist/addtowishlist/addtowishlistresponse';
import { BuyMusicChannelAPI } from '../api/wishlist/buymusicchannel/buymusicchannelapi';
import { BuyMusicChannelRequest } from '../api/wishlist/buymusicchannel/buymusicchannelrequest';
import { BuyMusicChannelResponse } from '../api/wishlist/buymusicchannel/buymusicchannelresponse';
import { DeleteFromWishlistAPI } from '../api/wishlist/deletefromwishlist/deletefromwishlistapi';
import { DeleteFromWishlistRequest } from '../api/wishlist/deletefromwishlist/deletefromwishlistrequest';
import { DeleteFromWishlistResponse } from '../api/wishlist/deletefromwishlist/deletefromwishlistresponse';
import { GetMusicBoxContentsAPI } from '../api/wishlist/getmusicboxcontents/getmusicboxcontentsapi';
import { GetMusicBoxContentsRequest } from '../api/wishlist/getmusicboxcontents/getmusicboxcontentsrequest';
import { GetMusicBoxContentsResponse } from '../api/wishlist/getmusicboxcontents/getmusicboxcontentsresponse';
import { GetWishlistAPI } from '../api/wishlist/getwishlist/getwishlistapi';
import { GetWishlistRequest } from '../api/wishlist/getwishlist/getwishlistrequest';
import { GetWishlistResponse } from '../api/wishlist/getwishlist/getwishlistresponse';
import { AddToWishlistAPIProcessorImpl } from '../processor/addtowishlistapiprocessor';
import { APIProcessor } from '../processor/apiProcessor';
import { BuyMusicChannelAPIProcessorImpl } from '../processor/buymusicchannelapiprocessor';
import { BuyToneAPIProcessorImpl } from '../processor/buytoneapiprocessor';
import { DeleteFromWishlistAPIProcessorImpl } from '../processor/deletefromwishlistapiprocessor';
import { DeleteToneAPIProcessorImpl } from '../processor/deletetoneapiprocessor';
import { GetMusicBoxContentsAPIProcessorImpl } from '../processor/getmusicboxcontentsapiprocessor';
import { GetTonePriceAPIProcessorImpl } from '../processor/gettonepriceapiprocessor';
import { GetWishlistAPIProcessorImpl } from '../processor/getwishlistapiprocessor';
import { GiftToneAPIProcessorImpl } from '../processor/gifttoneapiprocessor';
import { LikeToneAPIProcessorImpl } from '../processor/liketoneapiprocessor';
import { PreviewToneAPIProcessorImpl } from '../processor/previewtoneapiprocessor';
import { ReferToneAPIProcessorImpl } from '../processor/refertoneapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';
import { GetTonePriceNonLoggedInUserAPI } from '../api/tune/gettuneprice/gettonepricenonloggedinuserapi';
import { BuyToneNonLoggedInUserAPI } from '../api/tune/buytune/buytonenonloggeduserapi';
import { GetTonePriceNonLoggedInUserAPIProcessorImpl } from '../processor/gettonepricenonloggedinuserapiprocessor';
import { BuyToneNonLoggedInUserAPIProcessorImpl } from '../processor/buytonenonloggedinuserapiprocessor';
/* import { ListLikeToneRequest } from '../api/listlikedtone/listliketonerequest';
import { ListLikeToneResponse } from '../api/listlikedtone/listliketoneresponse';
import { ListLikeToneAPI } from '../api/listlikedtone/listliketoneapi';
import { ListLikeToneAPIProcessorImpl } from '../processor/listliketoneapiprocessor'; */

export class ToneProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(ToneProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getBuyToneAPIProcessor():APIProcessor<BuyToneRequest, BuyToneResponse>
    {
        this.logger.log("getBuyToneAPIProcessor() invoked");
        return new BuyToneAPIProcessorImpl(this.getContext(), new BuyToneAPI(this.getHttpClient(), this.getContext()));
    }

    getBuyToneNonLoggedUserAPIProcessor():APIProcessor<BuyToneRequest, BuyToneResponse>
    {
        this.logger.log("getBuyToneAPIProcessor() invoked");
        return new BuyToneNonLoggedInUserAPIProcessorImpl(this.getContext(), new BuyToneNonLoggedInUserAPI(this.getHttpClient(), this.getContext()));
    }

    getGiftToneDetails():APIProcessor<GiftToneRequest, GiftToneResponse>
    {
        this.logger.log("getGiftToneDetails() invoked");
        return new GiftToneAPIProcessorImpl(this.getContext(), new GiftToneAPI(this.getHttpClient(), this.getContext()));
    }

    getLikeToneDetails():APIProcessor<LikeToneRequest, LikeToneResponse>
    {
        this.logger.log("getLikeToneDetails() invoked");
        return new LikeToneAPIProcessorImpl(this.getContext(), new LikeToneAPI(this.getHttpClient(), this.getContext()));
    }

    /* getListLikeToneDetails():APIProcessor<ListLikeToneRequest, ListLikeToneResponse>
    {
        this.logger.log("getListLikeToneDetails() invoked");
        return new ListLikeToneAPIProcessorImpl(this.getContext(), new ListLikeToneAPI(this.getHttpClient(), this.getContext()));
    } */

    getReferToneDetails():APIProcessor<ReferToneRequest, ReferToneResponse>
    {
        this.logger.log("getReferToneDetails() invoked");
        return new ReferToneAPIProcessorImpl(this.getContext(), new ReferToneAPI(this.getHttpClient(), this.getContext()));
    }

    getGetTonePriceAPIProcessor():APIProcessor<GetTonePriceRequest, GetTonePriceResponse>
    {
        this.logger.log("getGetTonePriceAPIProcessor() invoked");
        return new GetTonePriceAPIProcessorImpl(this.getContext(), new GetTonePriceAPI(this.getHttpClient(), this.getContext()));
    }

    getGetTonePriceAPIProcessorNonLoggedInUser():APIProcessor<GetTonePriceRequest, GetTonePriceResponse>
    {
        this.logger.log("getGetTonePriceAPIProcessor() invoked");
        return new GetTonePriceNonLoggedInUserAPIProcessorImpl(this.getContext(), new GetTonePriceNonLoggedInUserAPI(this.getHttpClient(), this.getContext()));
    }

    getAddToWishlist():APIProcessor<AddToWishlistRequest, AddToWishlistResponse>
    {
        this.logger.log("getAddToWishlist() invoked");
        return new AddToWishlistAPIProcessorImpl(this.getContext(), new AddToWishlistAPI(this.getHttpClient(), this.getContext()));
    }

    getDeleteFromWishlist():APIProcessor<DeleteFromWishlistRequest, DeleteFromWishlistResponse>
    {
        this.logger.log("getDeleteFromWishlist() invoked");
        return new DeleteFromWishlistAPIProcessorImpl(this.getContext(), new DeleteFromWishlistAPI(this.getHttpClient(), this.getContext()));
    }

    getGetWishlist():APIProcessor<GetWishlistRequest, GetWishlistResponse>
    {
        this.logger.log("getGetWishlist() invoked");
        return new GetWishlistAPIProcessorImpl(this.getContext(), new GetWishlistAPI(this.getHttpClient(), this.getContext()));
    }

    getMusicBoxContents():APIProcessor<GetMusicBoxContentsRequest, GetMusicBoxContentsResponse>
    {
        this.logger.log("getMusicBoxContents() invoked");
        return new GetMusicBoxContentsAPIProcessorImpl(this.getContext(), new GetMusicBoxContentsAPI(this.getHttpClient(), this.getContext()));
    }

    getBuyMusicChannel():APIProcessor<BuyMusicChannelRequest, BuyMusicChannelResponse>
    {
        this.logger.log("getBuyMusicChannel() invoked");
        return new BuyMusicChannelAPIProcessorImpl(this.getContext(), new BuyMusicChannelAPI(this.getHttpClient(), this.getContext()));
    }

    getPreviewTone():APIProcessor<PreviewToneRequest, PreviewToneResponse>
    {
        this.logger.log("getPreviewTone() invoked");
        return new PreviewToneAPIProcessorImpl(this.getContext(), new PreviewToneAPI(this.getHttpClient(), this.getContext()));
    }

    getDelteTone():APIProcessor<DeleteToneRequest, DeleteToneResponse>
    {
        this.logger.log("getDeleteTone() invoked");
        return new DeleteToneAPIProcessorImpl(this.getContext(), new DeleteToneAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/toneprocessorfactory.tsx